import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrandingProvider } from '@alterrego/module-branding';
import App from './App';

// BrandingProvider résout le tenant (sous-domaine boostore.com → env → fallback)
// et applique ses variables CSS de marque sur :root. Pour Sauf Imprévu, ces
// variables sont identiques à celles déjà déclarées dans global.css → aucun
// changement visuel. Le fallback garantit le comportement historique si la
// résolution runtime échoue.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrandingProvider fallbackTenant="sauf-imprevu">
      <App />
    </BrandingProvider>
  </React.StrictMode>,
);
